<template>
  <div>
    <v-menu
      v-model="menu.show"
      :position-x="menu.x"
      :position-y="menu.y"
      absolute
      offset-y
    >
      <v-list>
        <v-list-item @click="dialog_vencidos = true">
          <v-list-item-title>
            <v-icon>$ClipboardTextClock</v-icon>
            Listar pedidos vencidos
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-data-table
      id="table-lista-pedido"
      v-model="pedidosSelecionados"
      :items="itensFiltrados"
      :items-per-page="50"
      :fixed-header="true"
      :headers="headers"
      :search="pesquisarProdutoEmPedido ? '' : search"
      show-select
      item-key="idpedido"
      no-data-text="Carregando lista de Pedidos... aguarde."
      :height="ALTURA_TABELA"
      :item-height="50"
      :footer-props="{
        'items-per-page-options': [50, 100, 150, -1],
      }"
      :show-expand="pesquisarProdutoEmPedido"
      @contextmenu:row="exibirMenu"
    >
      <template v-slot:top>
        <v-toolbar flat color="white" height="60px">
          <v-toolbar-title>Pedidos de Separação</v-toolbar-title>

          <v-divider class="mx-4" inset vertical></v-divider>

          <v-btn
            v-show="pedidosSelecionados.length > 0"
            color="red"
            @click="excluir(pedidosSelecionados)"
            small dark
          >
            <v-icon small left>mdi-delete</v-icon>
            <span>Remover</span>
            <span class="qtde-top-button-small">{{ pedidosSelecionados.length }}</span>
          </v-btn>

          <v-spacer></v-spacer>

          <v-switch
            v-model="pesquisarProdutoEmPedido"
            hide-details
            class="mt-2 mr-7"
          >
            <template v-slot:label>
              <span class="ml-2">Pesquisar produto em Pedidos</span>
            </template>
          </v-switch>

          <v-autocomplete
            v-model="separadorSelecionado"
            :items="listaDeSeparadores"
            item-text="name_user"
            item-value="id_separador"
            label="Filtro Separador"
            single-line
            hide-details
            multiple
            class="sys-autocomplete-drp-separadores"
            style="max-width: 450px"
          >
            <template v-slot:prepend-item>
              <v-list-item
                class="sys-item-prepended-list px-14px py-2"
                @click="selecionarTodosSeparadores()"
              >
                <template
                  v-if="
                    separadorSelecionado.length === listaDeSeparadores.length
                  "
                >
                  <v-icon color="primary">mdi-checkbox-marked</v-icon>
                  <span class="subtitle-1 ml-3">Desmarcar Todos</span>
                </template>
                <template v-else>
                  <v-icon v-if="!separadorSelecionado.length"
                    >mdi-checkbox-blank-outline</v-icon
                  >
                  <v-icon v-else color="primary">mdi-minus-box</v-icon>
                  <span class="subtitle-1 ml-3">Selecionar Todos</span>
                </template>
              </v-list-item>

              <v-divider />
            </template>

            <template v-slot:append>
              <v-chip
                v-if="separadorSelecionado.length > 0"
                small
                outlined
                style="font-size: 12px; color: #444"
              >
                <span
                  v-if="
                    separadorSelecionado.length === listaDeSeparadores.length
                  "
                >
                  Todos Selecionados
                </span>
                <span v-else>
                  {{
                    `${separadorSelecionado.length} selecionado${
                      separadorSelecionado.length > 1 ? "s" : ""
                    }`
                  }}
                </span>
              </v-chip>

              <v-icon v-else>mdi-filter</v-icon>
            </template>
          </v-autocomplete>

          <v-text-field
            id="txt-pesquisa-data-table"
            v-model="search"
            append-icon="mdi-magnify"
            label="Pesquisa"
            placeholder="Pesquisa"
            single-line
            hide-details
            clearable
            v-lazy-input:debounce="500"
            class="pl-7"
            style="max-width: 400px"
          ></v-text-field>
        </v-toolbar>
      </template>

      <template #item.idpedido="{ item }">
        <div class="d-flex align-center">
          {{ item.idpedido }}

          <DialogListaDePedido
            v-if="item.exportacao_gemco"
            :id_pedido="Number(item.idpedido)"
          />

          <ResultadoExportacaoComSucessoCisspoderIntegrimDialog
            v-if="integracao_exportacao_cisspoder_integrim && item.exportacao_cisspoder_integrim"
            :idpedido_systock="Number(item.idpedido)"
          />

          <ResultadoExportacaoComSucessoNativaWinthorDialog
            v-if="item.exportacao_nativa_winthor"
            :idpedido_systock="Number(item.idpedido)"
          />

          <ResultadoExportacaoComSucessoCasaTudoSacolaoDialog
            v-if="item.exportacao_casa_tudo_sacolao"
            :idpedido_systock="Number(item.idpedido)"
          />
        </div>
      </template>

      <template v-slot:item.src_modulo="{ item }">
        <v-icon>{{ item.src_modulo }}</v-icon>
      </template>

      <template v-slot:item.action="{ item }">
        <div class="d-flex">
          <ResultadoExportacaoWinthorJurunense v-if="item.exportacao_winthor" :pedido="item" />

          <template
            v-if="
              exportacaoProtheus && item.status === 'AB' && item.qtde_pedido > 0
            "
          >
            <incluir-pedido-loja-drp
              :pedido="item"
              icon
              @pedido-exportado="listar()"
            ></incluir-pedido-loja-drp>
          </template>

          <template v-if="exportacaoProtheus && item.status !== 'AB'">
            <v-tooltip bottom open-delay="500">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="abrirDialogStatusExportacaoProtheus(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </template>
              <span>Visualizar status da exportação para o Protheus.</span>
            </v-tooltip>

            <v-tooltip bottom open-delay="500">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="abrirDialogExportacaoProtheus(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-file-eye</v-icon>
                </v-btn>
              </template>
              <span>Visualizar resultado da exportação para o Protheus.</span>
            </v-tooltip>
          </template>

          <template v-if="!exportacaoProtheus || item.status === 'SP'">
            <v-btn icon>
              <v-icon title="Imprimir Relatório" @click="tipoRel(item)"
                >mdi-file-document</v-icon
              >
            </v-btn>
          </template>

          <v-btn v-if="item.status == 'FN' || item.status == 'AB'" icon disabled>
            <v-icon>mdi-pencil</v-icon>
          </v-btn>

          <v-btn v-else icon title="Editar Pedido" @click="editItem(item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>

          <template v-if="(exportacaoProtheus && item.status === 'AB') || !exportacaoProtheus">
            <v-btn
              icon
              v-if="!(item.status == 'FN' && item.qtde_pedido > 0) && !item.exportacao_winthor"
              @click="excluir([item])"
            >
              <v-icon title="Excluir Pedido">mdi-delete</v-icon>
            </v-btn>

            <v-btn icon v-else disabled>
              <v-icon title="Excluir Pedido">mdi-delete</v-icon>
            </v-btn>
          </template>
        </div>
      </template>

      <template v-slot:expanded-item="{ item }" v-if="pesquisarProdutoEmPedido">
        <td :colspan="headers.length + 1" class="py-5 pl-lg-15 pr-5">
          <h3 class="mt-1">
            <v-icon left small>mdi-format-list-bulleted-square</v-icon>
            Lista de Produtos do Pedido #{{ item.idpedido }}
          </h3>

          <tabela-de-produtos-do-pedido :pedido="item" :pesquisa="search" />
        </td>
      </template>
    </v-data-table>

    <v-dialog persistent v-model="dialogEditar" max-width="600px" content-class="bra-20">
      <v-card>
        <v-card-title>
          <span class="font-18 font-weight-medium">Pedido de separação</span>

          <v-spacer />

          <v-btn icon @click="dialogEditar = false;$v.$reset();">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="mt-2">
          <v-text-field
            label="Conferente de Saida*"
            outlined
            :error-messages="confSaidaErrors"
            :disabled="form.status != 'SP'"
            v-model="form.conf_saida"
            @input="$v.form.conf_saida.$touch()"
          />

          <v-text-field
            label="Conferente de Entrada*"
            outlined
            :disabled="conferenteSaida < 1 || form.status == 'FN'"
            v-model="form.conf_entrada"
            :messages="conferenteSaida < 1 ? 'Habilitado após salvar o conferente de saída' : ''"
          />

          <v-textarea
            outlined
            label="Observações"
            v-model="form.observacoes"
            rows="3"
            hide-details
          />
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn color="primary" text @click="salvar">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--Dialog tipo de relatorio-->
    <tipo-relatorio
      :dialog="dialogTipoRelatorio"
      :id="idpedido"
      @rClose="dialogTipoRelatorio = false"
    />

    <dialog-resultado-exportacao
      v-model="dialogResultadoExportacao"
      :resultado="resultadoExportacao"
    ></dialog-resultado-exportacao>

    <dialog-status-exportacao-protheus
      v-model="dialogStatusExportacao"
      :item="itemSelecionado"
      @atualizar-pedidos="listar()"
      ></dialog-status-exportacao-protheus>

      <DialogPedidosVencidos
      v-model="dialog_vencidos"
      @atualizar-pedidos="listar()"
    />
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import DrpAPI, {buscarResultadoExportcaoProtheus} from "../../../api/drp/pedido";
import TipoRelatorio from "../separacaoDeMercadorias/TipoRelatorio";
import tabelaDeProdutosDoPedido from "../separacaoDeMercadorias/pedidosDeSeparacao/tabelaDeProdutosDoPedido";
import IncluirPedidoLojaDrp from "../separacaoDeMercadorias/exportacaoProtheus/IncluirPedidoLojaDrp";
import DialogResultadoExportacao from "../separacaoDeMercadorias/exportacaoProtheus/DialogResultadoExportacao";
import DialogStatusExportacaoProtheus from "../separacaoDeMercadorias/exportacaoProtheus/DialogStatusExportacaoProtheus";
import {logout} from "@/helpers";
import DialogPedidosVencidos from "./DialogPedidosVencidos.vue";
import ResultadoExportacaoWinthorJurunense from "@/components/drp/separacaoDeMercadorias/ExportacaoParaERP/Winthor/ResultadoExportacao.vue";
import ResultadoExportacaoComSucessoCisspoderIntegrimDialog from "@/components/drp/separacaoDeMercadorias/ExportacaoParaERP/CisspoderIntegrim/ResultadoExportacaoComSucessoDialog.vue";
import ResultadoExportacaoComSucessoNativaWinthorDialog from "@/components/drp/separacaoDeMercadorias/ExportacaoParaERP/NativaWinthor/ResultadoExportacaoComSucessoDialog.vue";
import DialogListaDePedido from "@/components/drp/separacaoDeMercadorias/ExportacaoParaERP/Gemco/DialogListaDePedido.vue";
import ResultadoExportacaoComSucessoCasaTudoSacolaoDialog from "@/components/drp/separacaoDeMercadorias/ExportacaoParaERP/CasaTudoSacolao/ResultadoExportacaoComSucessoDialog.vue";
import ResponsiveHeight from "@/helpers/ResponsiveHeight";

export default {
  mixins: [ResponsiveHeight],
  components: {
    ResultadoExportacaoComSucessoCisspoderIntegrimDialog,
    TipoRelatorio,
    IncluirPedidoLojaDrp,
    DialogResultadoExportacao,
    DialogStatusExportacaoProtheus,
    tabelaDeProdutosDoPedido,
    DialogPedidosVencidos,
    ResultadoExportacaoWinthorJurunense,
    ResultadoExportacaoComSucessoNativaWinthorDialog,
    ResultadoExportacaoComSucessoCasaTudoSacolaoDialog,
    DialogListaDePedido
  },
  props: ["atualizarPedido"],
  data() {
    return {
      menu: {
        show: false,
        x: 0,
        y: 0
      },
      headers: [
        { text: "ID", value: "idpedido", align: "center" },
        { text: "Separador", value: "name_user" },
        { text: "Filiais de Destino", value: "filiais_destino" },
        { text: "Data Emissao", value: "data_emissao", align: "center" },
        { text: "Status", value: "status_desc" },
        { text: "Data Saida", value: "data_conf_saida", align: "center" },
        { text: "Data Entrada", value: "data_conf_entrada", align: "center" },
        { text: "Qtde. Itens Pedido", value: "qtde_pedido", align: "center" },
        {
          text: "Acões",
          value: "action",
          sortable: false,
          width: "150px",
          align: "center",
        },
      ],
      itens: [],
      search: "",
      dialog_vencidos: false,
      dialogEditar: false,
      dialogTipoRelatorio: false,
      idpedido: 0,
      atualizarCar: 0,
      conferenteSaida: "",
      form: {
        conf_entrada: "",
        conf_saida: "",
        observacoes: "",
      },
      separadorSelecionado: [],
      pesquisarProdutoEmPedido: false,
      timer: null,
      exportacaoProtheus: false,
      dialogResultadoExportacao: false,
      dialogStatusExportacao: false,
      resultadoExportacao: {},
      itemSelecionado: {},
      integracao_exportacao_cisspoder_integrim: localStorage.integracao_exportacao_cisspoder_integrim === 'S',
      pedidosSelecionados: [],
    };
  },
  created() {
    this.listar();
  },
  watch: {
    atualizarPedido() {
      this.listar();
    },
    search() {
      this.buscarProdutosEmPedidos();
    },
    pesquisarProdutoEmPedido(value) {
      const el = document.getElementById("txt-pesquisa-data-table");

      if (el) {
        el.focus();
        el.select();
      }

      if (value) {
        this.itens = [];
        this.buscarProdutosEmPedidos();
      } else {
        this.listar();
      }
    },
  },
  validations: {
    form: {
      conf_saida: {
        required,
      },
    },
  },
  computed: {
    confSaidaErrors() {
      const errors = [];
      if (!this.$v.form.conf_saida.$dirty) return errors;
      !this.$v.form.conf_saida.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    listaDeSeparadores() {
      let separadores = [];

      this.itens.forEach((item) => {
        const existe = separadores.filter(
          (separador) => separador.id_separador == item.id_separador
        );

        if (existe.length == 0) {
          const { id_separador, name_user } = item;

          separadores.push({ id_separador, name_user });
        }
      });

      return separadores;
    },
    itensFiltrados() {
      return this.itens.filter((item) =>
        this.separadorSelecionado.length > 0
          ? this.separadorSelecionado.includes(item.id_separador)
          : true
      );
    },
    ALTURA_TABELA () {
      let altura = this.alturaDaJanela - 270;
      return altura;
    },
  },
  methods: {
    exibirMenu (e) {
      e.preventDefault();
      this.menu.show = false;
      this.menu.x = e.clientX;
      this.menu.y = e.clientY;
      this.$nextTick(() => {
        this.menu.show = true;
      })
    },
    abrirDialogStatusExportacaoProtheus(item) {
      this.itemSelecionado = item;
      this.dialogStatusExportacao = true;
    },
    abrirDialogExportacaoProtheus(item) {
      this.$store.dispatch('loading/addRequisicao',
        buscarResultadoExportcaoProtheus(item.idpedido)
          .then(exportacao => {
            this.resultadoExportacao = exportacao.exportacao;
            this.dialogResultadoExportacao = true;
          })
          .catch(logout)
      );
    },
    selecionarTodosSeparadores() {
      if (this.separadorSelecionado.length === this.listaDeSeparadores.length) {
        this.separadorSelecionado = [];
      } else {
        this.separadorSelecionado = this.Helpers.arrayColumn(
          this.listaDeSeparadores,
          "id_separador"
        );
      }
    },
    buscarProdutosEmPedidos() {
      if (!this.pesquisarProdutoEmPedido) {
        return 0;
      }

      window.clearTimeout(this.timer);

      this.timer = window.setTimeout(() => {
        this.listar(this.search);
      }, 500);
    },
    listar(pesquisa = "") {
      this.itens = [];
      const params = { pesquisa };

      DrpAPI.Itens(params).then((resp) => {
        const { itens, exportacao_protheus } = resp;
        this.itens = itens;
        this.exportacaoProtheus = exportacao_protheus;
      });
    },
    excluir(itens) {
      if (confirm("Deseja realmente EXCLUIR este pedido?")) {

        const data = {idsPedidos: []};
        itens.forEach(item => data.idsPedidos.push(item.idpedido));

        DrpAPI
          .Excluir(data)
          .then((resp) => {
            if (resp.mensagem) {
              alert(resp.mensagem);
              return;
            }

            this.itens = resp.itens;
            this.pedidosSelecionados = [];

            itens.forEach(item => {
              if (item.status == "AB") {
                this.$emit("atualizarCarrinho", (this.atualizarCar += 1));
              }
            });
          });
      }
    },
    salvar() {
      this.$v.$touch();
      if (!this.$v.$invalid && this.form.status != "FN") {
        DrpAPI.Salvar(this.form).then((resp) => {
          this.dialogEditar = false;
          this.itens = resp;
        });
      }
    },
    tipoRel(item) {
      if (item.status == "AB") {
        this.finalizar(item.idpedido);
      } else {
        this.idpedido = item.idpedido;
        this.dialogTipoRelatorio = true;
      }
    },
    finalizar(id) {
      if (confirm("Deseja finalizar o pedido?")) {
        DrpAPI.Finalizar({ pedido: id }).then(() => {
          this.listar();
          this.idpedido = id;
          this.dialogTipoRelatorio = true;
        });
      }
    },
    editItem(item) {
      this.conferenteSaida = item.conf_saida;
      this.form = item;
      this.dialogEditar = true;
    },
  },
};
</script>

<style scoped>
.px-14px {
  padding-left: 14px;
  padding-right: 14px;
}
</style>

<style>
#table-lista-pedido .v-data-table__wrapper {
  height: calc(100vh - 263px) !important;
}
#table-lista-pedido .v-data-table__wrapper table thead tr th {
  vertical-align: top !important;
  padding-left: 6px !important;
  padding-right: 6px;
  padding-top: 5px !important;
  font-size: 9pt !important;
}
#table-lista-pedido .v-data-table__wrapper table tbody tr td {
  font-size: 9pt !important;
}
.sys-autocomplete-drp-separadores .v-select__selections {
  flex-wrap: nowrap;
  overflow: hidden;
}
.v-data-table__checkbox {
  text-align: center;
}
</style>
